import {FC} from 'react'

import {TextFontWeight} from '@/components/common/content/Text'
import {useFormSummaryContent} from '@/content/formSummary'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {Currency} from '@/utils/currency'

import {FormTooltip} from '../../tooltip/FormTooltip'
import {FormSummaryItem} from '../common/layout/FormSummaryItem'

type FormSummaryTotalPriceProps = {
  priceVatBase: number
  priceVat: number
  priceWithVat: number
  currency: Currency
}

export const FormSummaryTotalPrice: FC<FormSummaryTotalPriceProps> = ({
  priceVatBase,
  priceVat,
  priceWithVat,
  currency,
}) => {
  const {t} = useTranslation()
  const {priceExclVatTitle, vatTitle, vatTooltip, priceInclVatTitle} = useFormSummaryContent()

  return (
    <>
      <div>
        <FormSummaryItem
          title={t(priceExclVatTitle)}
          price={priceVatBase}
          textColor={theme.palette.text.default}
          currency={currency}
        />
      </div>
      <div>
        <FormSummaryItem
          title={t(vatTitle)}
          price={priceVat}
          tooltip={<FormTooltip tooltipText={t(vatTooltip)} />}
          textColor={theme.palette.text.default}
          currency={currency}
        />
      </div>
      <div>
        <FormSummaryItem
          title={t(priceInclVatTitle)}
          price={priceWithVat}
          fontWeight={TextFontWeight.bold}
          textColor={theme.palette.text.default}
          currency={currency}
        />
      </div>
    </>
  )
}
